<template>
  <div class="local-filter-tree">

    <advertising-local-tree v-if="!isPartnerCampaign"
                            :list="list"
                            :loaded="loaded"
                            :load-error="loadError"
                            @toggle-node="toggleNode" />

    <template v-else>
      <vue-nestable v-model="dataList"
                    :maxDepth="0"
                    keyProp="localTreeId">

        <div class="item"
             slot-scope="{ item }">
          <local-list-item :node="item"
                           :advertising="advertising"
                           :no-confirm="noConfirm"
                           :isPartnerCampaign="isPartnerCampaign"
                           @toogle-establishment="toggleEstablishment"
                           @set-priority="emitPriority"
                           @setChildren="setChildren"
                           @toogle="toggleNode"
                           @setIsOpen="$emit('setIsOpenArray', $event)" />
        </div>

        <div slot="placeholder"></div>
      </vue-nestable>

      <!-- FIX IT: gambiarra to make list work-->
      <p style="opacity: 0; margin: 0; height: 0;">teste</p>

      <infinite-loading :identifier="infiniteId"
                        @infinite="load">
        <div slot="no-results">Nenhum resultado encontrado</div>
        <div slot="no-more"></div>
      </infinite-loading>
    </template>
  </div>
</template>

<script>
import { VueNestable } from "vue-nestable";
import LocalListItem from "@views/users/components/LocalListItem.vue";
//import VueTreeselect from '@riophae/vue-treeselect'
import AdvertisingLocalTree from "./AdvertisingLocalTree";
import InfiniteLoading from "vue-infinite-loading";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import EventBus from "@packages/event-bus";

export default {
  components: {
    InfiniteLoading,
    // VueTreeselect,
    LocalListItem,
    VueNestable,
    AdvertisingLocalTree,
  },

  data() {
    return {
      value: [],
      show: false,
      dataList: [],
      page: 0,
      infiniteId: +new Date(),
      search: "",
      searchTimeout: undefined,
      searching: false,
    };
  },

  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
    loadError: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
    },
    anunciante: {
      type: Boolean,
      default: false,
    },
    advertising: {
      type: Boolean,
      default: false,
    },
    noConfirm: {
      type: Boolean,
      default: false,
    },
    isPartnerCampaign: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    list(value) {
      if (!this.isPartnerCampaign) return;

      this.dataList = this.setIds(value);
    },
  },

  created() {
    EventBus.$on("RELOAD_LOCAL_FILTER_TREE", this.reloadList);
  },

  mounted() {
    if (!this.isPartnerCampaign && !this.loaded) this.$emit("load");
  },

  beforeDestroy() {
    EventBus.$off("RELOAD_LOCAL_FILTER_TREE", this.reloadList);
  },

  methods: {
    setSearching(value) {
      this.searching = !!value;
    },
    async toggleNode(node) {
      this.$emit("toggleNode", node);
    },
    toggleEstablishment(val) {
      this.$emit("toggle-establishment", val)
    },
    setIds(list) {
      return list.map((item) => {
        if (item.selected) {
          this.value.push(item.localTreeId || item.id);
        }
        let label = item.name;

        if (item.type === 1) {
          label = `${label} (${item.cidade} - ${item.estado})`;
        }

        return {
          ...item,
          children:
            item.children && item.children.length
              ? this.setIds(item.children)
              : undefined,
          label,
          localTreeId: item.localTreeId,
          isDisabled: this.anunciante && item.type === undefined,
        };
      });
    },
    async reloadList() {
      if (!this.isPartnerCampaign) return this.$emit("load");

      this.page = 0;
      this.dataList = [];

      this.infiniteId++;
    },
    async load($state) {
      this.$emit("load", $state);
    },
    async edit() {
      this.reloadList();

      this.show = true;
    },
    setChildren({ id, value }) {
      const path = this.getPathByIdentifier(id);

      let item = this.dataList[path[0]];
      for (let index = 1; index < path.length; index++) {
        item = item.children[path[index]];
      }

      item.children = value;
    },
    getPathByIdentifier(id, items = this.dataList) {
      let path = [];

      items.every((item, i) => {
        if (item["localTreeId"] === id) {
          path.push(i);
        } else if (item.children) {
          const childrenPath = this.getPathByIdentifier(id, item.children);

          if (childrenPath.length) {
            path = path.concat(i).concat(childrenPath);
          }
        }

        return path.length === 0;
      });

      return path;
    },
    emitPriority(val) {
      this.$emit("set-priority", val)
    }
  },
};
</script>

<style lang="scss" scoped>
.local-filter-tree {
  padding: 20px 40px 0;
  margin-bottom: 20px;
}
</style>
